import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import StorageKey from '../shared/StorageKey'

export default function ApprovalCallbackScreen(): React.ReactElement {
    const query = new URLSearchParams(useLocation().search)
    useEffect(() => {
        const code = query.get('approval_token')
        if (code) {
            localStorage.setItem(StorageKey.APPROVAL_TOKEN, code)
        }
        window.close()
    })
    return <div>{query.get('approval_token')}</div>
}
